import {fabric} from "fabric-with-gestures";
import Table from "./Table";

const radianInCircle = 6.28;
const BaseRadius = 35;

export default class Circle extends Table {
  maxLength = radianInCircle / 360 * 30;
  radius = null;
  length = radianInCircle / this.countPerson;

  constructor(
  ) {
    super();
    this.radius = BaseRadius;
    this.length = this.length > this.maxLength ? this.maxLength : this.length;
  }

  setDefaultAttr() {
    this.length = radianInCircle / this.countPerson;
    this.length = this.length > this.maxLength ? this.maxLength : this.length;
  }

  getLength() {
    var angle = 1;
    while (true) {
      if ((Math.PI * this.radius / 180) * (angle) >= 30) {
        break;
      }
      angle++;
    }
    return angle / 57.2958;
  }

  calculateLengthArc() {
    return (Math.PI * this.radius / 180) * (360 / (this.countPerson));
  }

  calculateDist() {
    this.setDefaultAttr();
    while (true) {
      if (this.calculateLengthArc() < 30) {
        this.radius = this.radius + 10;
      } else {
        break;
      }

    }
    this.length = this.getLength() - this.getLength() / 4;
    this.dist = (radianInCircle - this.length * this.countPerson) / this.countPerson;
  }

  drawChairs() {
    this.calculateDist();
    this.chairs = [];
    let countPerson = this.countPerson,
      startAngle = 0,
      endAngle,
      chair;

    while (countPerson--) {
      endAngle = startAngle + this.length;
      chair = new fabric.Circle({
        my: {
          id: this.groupId,
          type : 'chair'
        },
        originX: 'center',
        originY: 'center',
        objectCaching: false,
        radius: this.radius,
        stroke: this.colorChair,
        strokeWidth: 6,
        startAngle: startAngle,
        endAngle: endAngle,
        fill: ''
      });
      startAngle = endAngle + this.dist;
      this.chairs.push(chair);
    }
    return this;
  }
  getType(){
    return 'Circle';
  }
  drawTable() {
    this.group.push(new fabric.Circle({
        my: {
          id: this.groupId,
          type : 'table'
        },
        radius: this.radius,
        fill: this.colorTable,
        originX: 'center',
        originY: 'center',
         objectCaching: false
      })
    );
    return this;
  }

  setControlsVisibility(object){
    object.setControlsVisibility({
      tr: true,
      bl: false,
      tl: false,
      br: false,
      ml:false,
      mt: false,
      mr: false,
      mb: false,
      mtr: true
    })
  }
  calculatePositionTableName() {
    // Empty method
  }
}
